var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-15.932 -32.652)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 569",
    transform: "translate(15.932 32.652)",
    style: {
      fill: "none",
      opacity: 0.509
    },
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 157",
    d: "M34.81 54.826a1.837 1.837 0 0 1-.621 1.6c-.678.441-1.525.055-2.654-.386a9.13 9.13 0 0 0-3.558-.938 9.13 9.13 0 0 0-3.558.938 5.18 5.18 0 0 1-1.92.552 1.532 1.532 0 0 1-.678-.166 1.837 1.837 0 0 1-.621-1.6c0-3.035 2.937-7.726 6.777-7.726 3.896 0 6.833 4.691 6.833 7.726z",
    transform: "translate(-2.141 -5.91)",
    style: {
      fill: "#939393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 158",
    d: "M20.742 43.6c0 1.49-.773 2.7-1.821 2.7-.993 0-1.821-1.159-1.821-2.7s.773-2.7 1.821-2.7 1.821 1.159 1.821 2.7z",
    transform: "translate(-.305 -3.33)",
    style: {
      fill: "#939393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 159",
    d: "M29.142 38.5c0 1.49-.773 2.7-1.821 2.7-.993 0-1.821-1.159-1.821-2.7 0-1.49.773-2.7 1.821-2.7s1.821 1.214 1.821 2.7z",
    transform: "translate(-3.966 -1.12)",
    style: {
      fill: "#939393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 160",
    d: "M38.042 38.5c0 1.49-.773 2.7-1.821 2.7-.993 0-1.821-1.159-1.821-2.7 0-1.49.773-2.7 1.821-2.7.993 0 1.821 1.214 1.821 2.7z",
    transform: "translate(-7.848 -1.12)",
    style: {
      fill: "#939393"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 48",
    cx: 1.821,
    cy: 2.704,
    rx: 1.821,
    ry: 2.704,
    transform: "translate(31.29 37.569)",
    style: {
      fill: "#939393"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPet);
export default __webpack_public_path__ + "static/media/pet.35f569d72adf314bf6cd48c566fa5867.svg";
export { ForwardRef as ReactComponent };